import baseRoute from '../baseRoute';

type RouteDefinition = (
	`${typeof baseRoute}/:jobMaterialId/scheduled`
	| `${typeof baseRoute}/${number}/scheduled`
);

export const ROUTE: RouteDefinition = `${baseRoute}/:jobMaterialId/scheduled`;

export const URL = (jobMaterialId: number): RouteDefinition => `${baseRoute}/${jobMaterialId}/scheduled`;
